module.exports = __webpack_public_path__ + "static/img/office3.b395ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/office/office3.png
// module id = laX2
// module chunks = 1